module.exports = __webpack_public_path__ + "static/karussel1-bdfb6de24eb213e055eabf5b50bd6f11.jpg";